<template>
  <div class="">
    <create-book-tags> </create-book-tags>
  </div>
</template>

<script>
import CreateBookTags from "@/components/profile/book-tags/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    CreateBookTags,
  },
  created() {
    this.notifyQueue({
      text: "Crea Codice Documento",
      path: "book_tags.create",
      level: 3,
    });
  },
};
</script>
